import { Button } from '@cokitchen/cokitchen-components';
import React, { useState, useEffect } from 'react';
import './styles.scss';
import { useNavigate } from 'react-router-dom';
import { ROUTE_KEYS, STORAGE_KEYS } from 'utils/constants';
import GiftSelectedMemberModal from 'components/modals/gift-selected-member-modal';
import { calculateTimeRemaining, formatTime } from 'utils/functions';
import { MemberListType } from 'models/member.model';

type Props = {
  birthdays: MemberListType[];
};

const BirthdayReminder = ({ birthdays }: Props) => {
  const [timeRemaining, setTimeRemaining] = useState<number>(calculateTimeRemaining());
  const [showGiftModal, setShowGiftModal] = useState(false);
  const [person, setPerson] = useState<undefined | MemberListType>(undefined);
  const navigate = useNavigate();

  const giftMembers = () => {
    if (birthdays.length === 1) {
      setShowGiftModal(true);
      setPerson(birthdays[0]);
    } else if (birthdays.length > 1) {
      localStorage.setItem(STORAGE_KEYS.SELECTED_PEOPLE, JSON.stringify(birthdays));
      navigate(`${ROUTE_KEYS.APP}/${ROUTE_KEYS.GIFT_BULK_MEMBERS}`);
    }
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      setTimeRemaining(calculateTimeRemaining());
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <div className='w-full z-30 bg-[#F7F7F8] sm:min-h-[63px] h-fit py-2 sm:py-4 flex justify-center items-center gap-2 sm:gap-4 md:gap-16 flex-wrap birthday_wrap '>
      <p className='text-[#5E6164] text-center'>
        A couple of your team members have their birthdays in
        <span className='font-medium text-[#0080E5]'> {formatTime(timeRemaining)} 🎉</span>
      </p>
      <Button
        variant='block'
        color='transparent'
        className='!bg-white w-[139px] h-[39px] border-[#EAEBEB]'
        onClick={giftMembers}>
        Gift members
      </Button>
      <GiftSelectedMemberModal
        isOpen={showGiftModal}
        onClose={() => setShowGiftModal(false)}
        singlePeople={person}
        gift_type='Birthday'
      />
    </div>
  );
};

export default BirthdayReminder;
